<template>
  <div>
    <data-table-card item-add-route-name="administration-custom-email-template-add"
                     item-route-name="administration-custom-email-template"
                     v-bind:filter="filter"
                     v-bind:headers="headers"
                     v-bind:items="items"
                     v-bind:sort-by="[ 'isLayout', 'name' ]"
                     v-bind:title="$t('customEmailTemplates')">
      <template v-slot:item.name="{ item }">
        <span class="font-weight-medium">{{ item.name }}</span>
        <v-chip class="ml-2 sf-pill sf-pill--warning"
                x-small
                v-if="item.requiresConversion">
          <v-icon left
                  x-small>ti-alert-triangle</v-icon>
          {{ $t('requiresConversion') }}
        </v-chip>
      </template>
      <template v-slot:item.audienceLabel="{ item }">
        {{ item.audienceLabel }}
      </template>
      <template v-slot:item.isLayout="{ item }">
        <v-chip class="sf-pill"
                small
                v-bind:class="item.isLayout ? 'sf-pill--accent' : 'sf-pill--primary'">
          {{ item.isLayout ? $t('layout') : $t('email') }}
        </v-chip>
      </template>
      <template v-slot:item.modified="{ item }">
        <span class="sf-muted">{{ item.modified | formatDate('L LT') }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu left
                offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   small
                   v-bind:title="$t('actions')"
                   v-on:click.stop
                   v-on="on">
              <v-icon small>ti-dots</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <!-- Altformat: erst umwandeln, dann stehen Duplizieren/Layout zur Verfügung -->
            <v-list-item v-if="item.requiresConversion"
                         v-on:click="$emit('convert', { id: item.id })">
              <v-list-item-icon class="mr-3"><v-icon>ti-wand</v-icon></v-list-item-icon>
              <v-list-item-title>{{ $t('convert') }}</v-list-item-title>
            </v-list-item>
            <template v-else>
              <v-list-item v-on:click="$emit('duplicate', { id: item.id, name: `${item.name} (Kopie)`, kind: 'Email' })">
                <v-list-item-icon class="mr-3"><v-icon>ti-copy</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t('duplicate') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.kind !== 'Layout'"
                           v-on:click="$emit('duplicate', { id: item.id, name: `${item.name} (Layout)`, kind: 'Layout' })">
                <v-list-item-icon class="mr-3"><v-icon>ti-layout-dashboard</v-icon></v-list-item-icon>
                <v-list-item-title>{{ $t('saveAsLayout') }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </data-table-card>
  </div>
</template>

<script>
  import DataTableCard from '@/components/common/DataTableCard'

  export default {
    components: {
      DataTableCard
    },
    computed: {
      headers() {
        return [
          { text: this.$t('name'), value: 'name' },
          { text: this.$t('subject'), value: 'title' },
          { text: this.$t('audience'), value: 'audienceLabel', width: 140 },
          { text: this.$t('kind'), value: 'isLayout', width: 120 },
          { text: this.$t('modified'), value: 'modified', width: 170 },
          { text: '', value: 'actions', align: 'end', sortable: false, filterable: false, width: 70 }
        ]
      },
      filter() {
        return {
          property: 'state',
          values: [
            { name: 'all', showAll: true, title: this.$t('all') },
            { name: 'Customer', icon: 'ti-users', title: this.$t('customers') },
            { name: 'Supplier', icon: 'ti-truck', title: this.$t('suppliers') },
            { name: 'Layout', icon: 'ti-layout-dashboard', title: this.$t('layouts') }
          ]
        }
      },
      items() {
        return [ ...this.customEmailTemplates ]
          .map(t => ({
            ...t,
            // Der Filter der Tabelle arbeitet über "state"; wir nutzen das Feld für Zielgruppe bzw. Art.
            state: t.kind === 'Layout' ? 'Layout' : t.audience,
            isLayout: t.kind === 'Layout',
            audienceLabel: t.audience === 'Supplier' ? this.$t('suppliers') : this.$t('customers')
          }))
      }
    },
    name: 'CustomEmailTemplateList',
    props: {
      customEmailTemplates: Array
    }
  }
</script>

<i18n>
  {
    "de": {
      "actions": "Aktionen",
      "all": "Alle",
      "audience": "Zielgruppe",
      "convert": "In visuelle Vorlage umwandeln",
      "customEmailTemplates": "E-Mail-Vorlagen",
      "customers": "Kunden",
      "duplicate": "Duplizieren",
      "email": "E-Mail",
      "kind": "Art",
      "layout": "Layout",
      "layouts": "Layouts",
      "modified": "Geändert",
      "name": "Name",
      "requiresConversion": "Umwandlung erforderlich",
      "saveAsLayout": "Als Layout speichern",
      "subject": "Betreff",
      "suppliers": "Lieferanten"
    },
    "en": {
      "actions": "Actions",
      "all": "All",
      "audience": "Audience",
      "convert": "Convert to visual template",
      "customEmailTemplates": "Custom email templates",
      "customers": "Customers",
      "duplicate": "Duplicate",
      "email": "Email",
      "kind": "Kind",
      "layout": "Layout",
      "layouts": "Layouts",
      "modified": "Modified",
      "name": "Name",
      "requiresConversion": "Conversion required",
      "saveAsLayout": "Save as layout",
      "subject": "Subject",
      "suppliers": "Suppliers"
    }
  }
</i18n>
